export default __webpack_public_path__ + "static/media/more-rewind.f6a21177.svg";